import Rodal from 'rodal';
import 'rodal/lib/rodal.css';
import { Button } from '../../../shared/components/Button';
import { useState, useEffect } from 'react';

export const AIDisclaimerModal = ({ show, close }) => {
  const [isPhone, setIsPhone] = useState(false);

  useEffect(() => {
    const mediaQueryWidth = window.matchMedia('(max-width: 500px)');
    const handleMediaChange = () => {
      setIsPhone(mediaQueryWidth.matches);
    };
    handleMediaChange();
    mediaQueryWidth.addListener(handleMediaChange);
    return () => {
      mediaQueryWidth.removeListener(handleMediaChange);
    };
  }, []);

  return (
    <Rodal
      animation={'fade'}
      visible={show}
      onClose={close}
      className='df_ai_disclaimer_modal'
      customStyles={{
        border: '2px solid var(--onyx)',
        backgroundColor: 'var(--jet)',
        color: 'var(--ivory)',
        padding: '18px 10px 12px 20px',
        width: isPhone ? 'calc(100% - 34px)' : '400px',
        height: isPhone ? 'calc(100% - 34px)' : '500px',
      }}
    >
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <b style={{ margin: 0, textAlign: 'left', marginBottom: 12, fontSize: 21 }}>
          Our Stance on AI
        </b>

        <div
          style={{
            overflowY: 'auto',
            paddingRight: 8,
            lineHeight: 1.45,
            fontSize: 14,
            textAlign: 'left',
          }}
        >
          <p>
            The way we engage with TTRPGs is changing. AI is part of that
            reality -we understand this.
          </p>
          <p>
            Dimension Factory enables orchestration, visualized narration, and
            dynamic gameplay. These features often require a large number of
            visual assets. Because DF is also designed for rapid prototyping and
            playtesting, curating or commissioning artwork for every test
            scenario can sometimes be impractical.
          </p>
          <h3 style={{ marginBottom: 0 }}>So here is our stance</h3>
          <ul style={{ marginTop: 0 }}>
            <li>
              AI-generated assets are allowed within Dimension Factory, inside
              Progression tools and our Orchestrator.
            </li>
            <li>
              However,{' '}
              <b>Dimension Factory will never generate AI assets itself</b>. We
              deliberately avoid embedding AI generation tools into the
              platform.
            </li>
            <li>
              Even when allowed, the use of AI assets is discouraged. When
              possible, we strongly encourage players and creators to curate
              artwork or commission artists, especially for paid games,
              published content, or streamed sessions.
            </li>
            <li>
              One of our long-term goals is to curate and commission legally
              accessible asset libraries for players to use. In other words,{' '}
              <b>
                we want to make the non-AI path faster and easier than the AI
                one
              </b>
              .
            </li>
          </ul>
          <h3 style={{ marginBottom: 0 }}>Our Internal Use of AI</h3>
          At{' '}
          <a href='https://www.paradigms.gr' target='_blank' rel='noreferrer'>
            Paradigms
          </a>
          , we sometimes use AI-assisted coding tools. However, we enforce
          strict limitations:
          <ul style={{ marginTop: 0 }}>
            <li>
              AI is used for prototyping, automation, and playtesting only -not
              for feature or system development.
            </li>
            <li>
              All production systems are designed, reviewed, and owned by
              humans.
            </li>
            <li>
              AI has no access to user data. User assets are never used for
              training or analysis.
            </li>
          </ul>
          <p>
            At{' '}
            <a href='https://www.paradigms.gr' target='_blank' rel='noreferrer'>
              Paradigms
            </a>
            , <b>we make ethical software</b>. Helping independent creators
            brainstorm and prototype better TTRPG systems based on cutting-edge
            orchestration tools? <b>Deeply ethical.</b> Plagiarizing artists or
            replicating artistic styles for commercial gain?{' '}
            <b>Deeply unethical.</b> This is where we draw the line.
          </p>
          <h3 style={{ marginBottom: 0 }}>TL;DR</h3>
          <ul style={{ marginTop: 0 }}>
            <li>
              DF does not police AI assets. For private games or brainstorming,
              this is your choice.
            </li>
            <li>
              DF strongly discourages AI asset use in paid or streamed games.
            </li>
            <li>DF will never generate AI assets.</li>
          </ul>
        </div>

        <div
          style={{ marginTop: 12, display: 'flex', justifyContent: 'center' }}
        >
          <Button label={'Close'} type='onyx' onPress={close} />
        </div>
      </div>
    </Rodal>
  );
};
